import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import DeviceCheckPage from './DeviceCheckPage';
import DriverApp from './DriverApp';
import DriverGate from './DriverGate';
import { useDeliveryManifest } from './platform/manifest';

/**
 * /delivery/driver/* - the Delivery Portal's driver permission level.
 *
 * Imported EAGERLY by App.tsx (not React.lazy): a lazy chunk the phone has not
 * fetched would leave an offline start stuck on "Loading…". The whole driver
 * view is in the main bundle, which the service worker caches on first open.
 *
 * The delivery manifest is held here, not in a screen, so every driver page
 * (the route AND device check) installs as "RBF Deliveries".
 */
export default function DriverRoot() {
  useDeliveryManifest();
  return (
    <DriverGate>
      {(ctx) => (
        <Routes>
          <Route index element={<DriverApp session={ctx.session} offline={ctx.offline} notice={ctx.notice} />} />
          <Route path="device" element={<DeviceCheckPage />} />
          <Route path="*" element={<Navigate to="/delivery/driver" replace />} />
        </Routes>
      )}
    </DriverGate>
  );
}
